import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const getCurrentRoute = (
    state: IApplicationState
): ERoutes => {
    return state.router.route;
}
